
// Slick carousel (used on testimonials) http://kenwheeler.github.io/slick/
//import jquery from 'jquery'

import 'slick-carousel';

// window.jQuery = window.$ = $;

// Slick (Slider) http://kenwheeler.github.io/slick/
// Better include this before basicscroll
(function($) { "use strict";

	//
	// Hero Slider
	//
	var $slider = $('.js-hero-slider');
	
	// check page contains element
	if( $slider.length ) {
		
		
		// On first initialization
		$slider.on('init', function(slick) {
			
			let firstItem = $('.section-hero-slider .slick-dots li:first-child');
			
			// To trigger the first item's transition on page load
			firstItem.removeClass('slick-active');
			
			setTimeout(function() {
				firstItem.addClass('slick-active');
			}, 1);

			const slide_count = $slider.find('.hero-slide').length;
			
			// Populate the 'slide count'
			$('.section-hero-slider__paging .totalSlides').text(slide_count);

			// Populate the first 'slide kind'
			const slide_kind = $('.section-hero-slider .hero-slide:first-child').data('slide-kind');
			$('.section-hero-slider__paging .hero-slide__kind').text(slide_kind);



		});
		
		// On before slide change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			$('body').addClass('js-hero-active'); //Used to adjust animation-duration in CSS after the first slide is cycled.		

			// Update 'current slide' number
			$('.section-hero-slider__paging .currSlide').text(nextSlide + 1);
			

			// Populate the 'slide kind'
			const slide_kind = $('.hero-slide', slick.$slides[nextSlide]).data('slide-kind');
			$('.section-hero-slider__paging .hero-slide__kind').text(slide_kind);

			

		});



		
		// initialize and configure.
		$slider.slick({
			fade: true,
			dots: true,
			arrows: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 5000, // TODO SET BACK TO 5sec
			speed: 2000,
			appendDots: $('.paging-wrap'),
			customPaging: function(slider, i) {
				const currentSlide = $(slider.$slides[i]);
				const slide_count = slider.$slides.length;
				const slide_description = currentSlide.find('.hero-slide').data('slide-description') ?? '';
				i = i+1;
				let paging = '<span class="slide-description">' + i + '/' + slide_count + ' ' + slide_description + '</span>';
				// return paging;
				// return paging + '<span class="progress-number">' + i + '</span>';
			}
		});
		
		
	}


	//
	// Tease Slider
	//
	// check page contains element
	
	var $tease_slider = $('.js-tease-slider');

	if( $tease_slider.length ) {


		// On before slide change
		$tease_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			$(slick.$slider).addClass('js-changing');

		});

		// On after slide change
		$tease_slider.on('afterChange', function(event, slick, currentSlide){
			
			$(slick.$slider).removeClass('js-changing');

		});


		$tease_slider
			.on('activate-carousel', function (e, eventInfo) {

				if ($(this).data('active-carousel') === true) {
					return; //ensure we slick the carousel only if needed
				}

				$(this).slick({
					dots: false,
					arrows: true,
					slidesToShow: 6,
					slidesToScroll: 1,
					// pauseOnFocus: false,
					variableWidth: false,
					pauseOnHover: true,
					autoplay: false,
					touchThreshold: 30,
					// rtl: true,
					// autoplaySpeed: 4000,
					// speed: 300,
					prevArrow: '<span class="slick-prev icon-carousel-left"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
					nextArrow: '<span class="slick-next icon-carousel-right"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
					// responsive: [
					// 	{
					// 		breakpoint: 1000,
					// 		settings: {
					// 			centerMode: true,
					// 			centerPadding: '40px',
					// 			slidesToShow: 2
					// 		}
					// 	},
					// 	{
					// 		breakpoint: 750,
					// 		settings: {
					// 			centerMode: true,
					// 			centerPadding: '100px',
					// 			slidesToShow: 1
					// 		}
					// 	},
					// 	{
					// 		breakpoint: 650,
					// 		settings: {
					// 			centerMode: true,
					// 			centerPadding: '0px',
					// 			slidesToShow: 1
					// 		}
					// 	}
					// ]
				})

				$(this).data('active-carousel', true); //set the carousel as active
			})
			.on('deactivate-carousel', function (e, eventInfo) {
				if ($(this).data('active-carousel') === false) {
					return; //ensure we unslick the carousel only if needed
				}
				$(this).slick('unslick');
				$(this).data('active-carousel', false); //set carousel as non-active
			})
			.trigger('activate-carousel') //trigger the carousel at page loading
		;
	}

		
	

	//
	// Full width
	//
	// check page contains element
	if( $('.full-width-slider').length ) {


		$('.full-width-slider').slick({
					dots: false,
					arrows: false,
					slidesToShow: 3,
					slidesToScroll: 2,
					// centerMode: true,
					variableWidth: true,
					pauseOnHover: false,
					autoplay: false,
					touchThreshold: 30,
					speed: 1000,
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								centerMode: true,
								centerPadding: '40px',
								slidesToShow: 2
							}
						},
						{
							breakpoint: 750,
							settings: {
								centerMode: true,
								centerPadding: '100px',
								slidesToShow: 1
							}
						},
						{
							breakpoint: 650,
							settings: {
								centerMode: true,
								centerPadding: '0px',
								slidesToShow: 1
							}
						}
					]
		});
	}




	// dots: false,
	// arrows: true,
	// slidesToShow: 6,
	// slidesToScroll: 1,
	// // pauseOnFocus: false,
	// variableWidth: false,
	// pauseOnHover: true,
	// autoplay: false,
	// touchThreshold: 30,



	//
	// Block Images Slider
	//
	// check page contains element
	if( $('.block-images-slider').length ) {


		$('.block-images-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			// pauseOnFocus: false,
			variableWidth: false,
			pauseOnHover: true,
			autoplay: false,
			centerMode: false,
			touchThreshold: 30,
			infinite: true,
			// rtl: true,
			// autoplaySpeed: 4000,
			// speed: 300,
			prevArrow: '<span class="slick-prev icon-carousel-left"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
			nextArrow: '<span class="slick-next icon-carousel-right"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						centerMode: true,
						centerPadding: '40px',
						slidesToShow: 2
					}
				},
				{
					breakpoint: 750,
					settings: {
						centerMode: true,
						centerPadding: '100px',
						slidesToShow: 1
					}
				},
				{
					breakpoint: 650,
					settings: {
						centerMode: true,
						centerPadding: '0px',
						slidesToShow: 1
					}
				}
			]
		});
	}







		
		
	//
	// Gallery Slider
	//
	var $gallerySlider = $('.js-gallery-slider');
	
	// check page contains element
	if( $gallerySlider.length ) {
			
		// initialize and configure.
		$gallerySlider.slick({
			fade: true,
			dots: false,
			arrows: true,
			prevArrow: '<span class="gallery-prev icon-gallery-prev"><span class="path1"></span><span class="path2"></span></span>',
			nextArrow: '<span class="gallery-next icon-gallery-next"><span class="path1"></span><span class="path2"></span></span>',
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: false,
			infinite: true,
			speed: 1400
		});
		
		
	}		
		
		

})(jQuery);
